export interface LocationPoint { lat: number; lng: number }

// Mismo ámbito WGS84 que valida el backend; no reemplaza la comprobación de la dirección.
export function locationPoint(lat: unknown, lng: unknown): LocationPoint | null {
  if ((typeof lat !== "number" && typeof lat !== "string") || (typeof lng !== "number" && typeof lng !== "string")) return null;
  if (String(lat).trim() === "" || String(lng).trim() === "") return null;
  const latitude = Number(lat);
  const longitude = Number(lng);
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude) || latitude < -27.7 || latitude > -19.2 || longitude < -62.7 || longitude > -54.1) return null;
  return { lat: latitude, lng: longitude };
}

export function roundedLocation(point: LocationPoint, decimals: 3 | 6): LocationPoint {
  return { lat: Number(point.lat.toFixed(decimals)), lng: Number(point.lng.toFixed(decimals)) };
}
